/** Total & saldo Laporan APBDes (anggaran vs realisasi) — dipakai kartu dan widget /wall. */

export interface LaporanTotalsInput {
	totalIncomeBudget: number;
	totalExpenseBudget: number;
	totalIncomeReal: number;
	totalExpenseReal: number;
}

export interface LaporanTotals extends LaporanTotalsInput {
	/** Realisasi ÷ anggaran dibulatkan (%); 0 bila anggaran 0. */
	incomePercent: number;
	expensePercent: number;
	/** Anggaran pendapatan − anggaran belanja (cocok dengan baris rincian). */
	saldoBudget: number;
	/** Realisasi pendapatan − realisasi belanja. */
	saldoReal: number;
	/** Ada realisasi (> 0) pada pendapatan atau belanja. */
	hasReal: boolean;
}

function percentOf(real: number, budget: number): number {
	return budget > 0 ? Math.round((real / budget) * 100) : 0;
}

export function laporanTotals(
	report: LaporanTotalsInput | null | undefined,
): LaporanTotals {
	const incomeBudget = report?.totalIncomeBudget ?? 0;
	const expenseBudget = report?.totalExpenseBudget ?? 0;
	const incomeReal = report?.totalIncomeReal ?? 0;
	const expenseReal = report?.totalExpenseReal ?? 0;
	return {
		totalIncomeBudget: incomeBudget,
		totalExpenseBudget: expenseBudget,
		totalIncomeReal: incomeReal,
		totalExpenseReal: expenseReal,
		incomePercent: percentOf(incomeReal, incomeBudget),
		expensePercent: percentOf(expenseReal, expenseBudget),
		saldoBudget: incomeBudget - expenseBudget,
		saldoReal: incomeReal - expenseReal,
		hasReal: incomeReal > 0 || expenseReal > 0,
	};
}
